import { useAppSelector } from '../../hooks';
import { PaginationStore } from './pagination.reducer';

export const usePaginationSelector = (): PaginationStore =>
  useAppSelector(({ pagination }) => pagination);
